export const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://192.168.100.229:3001';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL ?? API_BASE_URL;